import React from 'react';
import FormField from "./FormField";
import {useFormikContext} from "formik";
import {findCountry, getCountries, getStateDisplayName, getStates, getZipCodeDisplayName} from "../../../utils/i18n";

const HouseholdField = ({entity, required}) => {
  const {values} = useFormikContext();
  const country = (values[entity] && values[entity]["country"])
    ? findCountry({label: values[entity]["country"]})
    : null;
  const countries = getCountries();
  const states = country ? getStates(country) : [];
  const zipLabel = getZipCodeDisplayName(country);
  const stateLabel = getStateDisplayName(country);

  return (
    <React.Fragment>
      <div className="row">
        <FormField label="Address 1" type="text" name={`${entity}.address_1`} colWidth={12} required={required} />
      </div>

      <div className="row">
        <FormField label="Address 2" type="text" name={`${entity}.address_2`} colWidth={12}/>
      </div>

      <div className="row">
        <FormField
          label="Country"
          type="select"
          name={`${entity}.country`}
          options={countries.map(country => country.label)}
          colWidth={6}
          required={required}
        />

        <FormField label="City" type="text" name={`${entity}.city`} colWidth={6} required={required} />

        {
          states.length !== 0
            ? (<FormField label={stateLabel} type="select" name={`${entity}.state`} options={states} colWidth={6} required={required} />)
            : (<FormField label={stateLabel} type="text" name={`${entity}.state`} colWidth={6} required={required} />)
        }

        <FormField label={zipLabel} type="text" name={`${entity}.zip`} colWidth={4} required={required} />
      </div>
    </React.Fragment>
  );
};

export default HouseholdField;
